/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */
import Jsona from 'jsona';
import Types from '../constants/actionTypes';
import * as API from '../utils/api';
import ItemTypes from '../constants/itemTypes';
import { applicationError } from './notificationActions';

const dataFormatter = new Jsona();

export function updateAttachmentsStore(attachments) {
  return (dispatch) =>
    dispatch({ type: Types.RECEIVE_ATTACHMENTS, attachments });
}

export function fetchAttachments(itemId, type) {
  const url = 'attachments';
  let data = {};

  if (type === 'workPackage' || type === ItemTypes.RESULT) {
    data = { attachment: { work_package_id: itemId } };
  } else if (type === 'task' || type === ItemTypes.TASK) {
    data = { attachment: { task_id: itemId } };
  } else if (type === 'product' || type === ItemTypes.PRODUCT) {
    data = { attachment: { product_id: itemId } };
  }

  return (dispatch) => {
    dispatch({ type: Types.REQUEST_ATTACHMENT });

    return API.get(url, data)
      .then((response) => {
        const attachments = dataFormatter.deserialize(response);
        dispatch({
          type: Types.RECEIVE_ATTACHMENTS,
          attachments
        });
      })
      .catch((error) => {
        dispatch({ type: Types.RECEIVE_ATTACHMENTS_ERROR });
        dispatch(applicationError(error));
      });
  };
}

export function fetchThumbnail(id) {
  const url = `attachments/${id}/thumbnail`;
  const reader = new FileReader();
 
  return (dispatch) => {
    reader.onloadend = () =>
      dispatch({
        type: Types.RECEIVE_THUMBNAIL,
        thumbnail: { [id]: reader.result }
      });

    return API.getAttachment(url)
      .then(
        (response) => response instanceof Blob && reader.readAsDataURL(response)
      )
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function downloadUrl(id) {
  const url = `attachments/${id}/file`;

  return (dispatch) =>
    API.getAttachment(url)
      .then(
        (response) =>
          response instanceof Blob &&
          dispatch({
            type: Types.RECEIVE_ATTACHMENT_FILE,
            file: { [id]: window.URL.createObjectURL(response) }
          })
      )
      .catch((error) => dispatch(applicationError(error)));
}

export function uploadAttachment(file, fileUrl, itemId, type) {
  const url = 'attachments';
  const data = new FormData();
  const fileCopy = file;
  fileCopy.path = fileUrl;
  data.append('attachment[file]', fileCopy);
  data.append('attachment[short_name]', fileCopy.name);

  if (type === 'workPackage' || type === ItemTypes.RESULT) {
    data.append('attachment[work_package_id]', itemId);
  } else if (type === 'task' || type === ItemTypes.TASK) {
    data.append('attachment[task_id]', itemId);
  } else if (type === 'product' || type === ItemTypes.TASK) {
    data.append('attachment[product_id]', itemId);
  }

  return (dispatch) => {
    dispatch({ type: Types.UPLOAD_ATTACHMENT });
    return API.filePost(url, data)
      .then((response) => response.json())
      .then((response) => {
        const attachments = dataFormatter.deserialize(response);

        dispatch({ type: Types.END_UPLOAD_ATTACHMENT, attachments });
        return response;
      })
      .catch((error) => {
        dispatch({ type: Types.END_UPLOAD_ATTACHMENT_ERROR });
        // const errorMessage = error && error.response && error.response.body;
        dispatch(applicationError(/*errorMessage ||*/ error));
      });
  };
}

export function uploadAttachments(attachments = [], itemId) {
  return (dispatch) =>
    attachments.reduce(
      (promise, attachment) =>
        promise.then(() =>
          dispatch(
            uploadAttachment(
              attachment.droppedFile,
              attachment.droppedFileUrl,
              itemId,
              attachment.type
            )
          )
        ),
      Promise.resolve()
    );
}

export function deleteAttachment(id) {
  const url = `attachments/${id}`;

  return (dispatch) => {
    dispatch({ type: Types.DELETE_ATTACHMENT });

    return API.del(url)
      .then(() => dispatch({ type: Types.END_DELETE_ATTACHMENT }))
      .catch((error) => dispatch(applicationError(error)));
  };
}

export function setCounting(counting) {
  return (dispatch) => {
    dispatch({ type: Types.SET_ATTACHMENT_COUNTING, counting });
  };
}
